// extracted by mini-css-extract-plugin
export default {"subtitle":"styles_subtitle__H7wlU","bottomContainer":"styles_bottomContainer__HGmSB","resetBtn":"styles_resetBtn__YyqF+"};